import * as React from 'react';
import { FavoriteButton as FavoriteButtonComponent } from '../../components/FavoriteButton';
import { useDispatch, useSelector } from 'react-redux';
import { favoriteSelector, gaLabelSelector, newbuildingIdSelector } from '../../selectors';
import { addFavorite, removeFavorite } from '../../services';
import { TThunkDispatch } from '../../types/redux';

export const FavoriteButton = () => {
  const dispatch: TThunkDispatch = useDispatch();

  const isFavorite = useSelector(favoriteSelector);
  const newbuildingId = useSelector(newbuildingIdSelector);
  const gaLabel = useSelector(gaLabelSelector);

  const onClick = React.useCallback(() => {
    if (isFavorite) {
      dispatch(removeFavorite(newbuildingId, gaLabel));
    } else {
      dispatch(addFavorite(newbuildingId, gaLabel));
    }
  }, [gaLabel, newbuildingId, isFavorite]);

  return <FavoriteButtonComponent isFavorite={isFavorite} onClick={onClick} />;
};
